import { inject } from '@angular/core';
import { Router, type CanActivateFn, type UrlTree } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Admin authorization guard for protected admin routes.
 * 
 * Checks if the authenticated user has admin privileges (admin: true in profile).
 * If not an admin, redirects to the /unauthorized page.
 * 
 * @remarks
 * This guard should be used in combination with authGuard. The authGuard ensures
 * the user is authenticated, and this guard ensures they have admin privileges.
 * 
 * The guard checks the admin field from the backend profile response, not Firebase.
 * This ensures proper server-side authorization.
 *
 * @returns True if user is admin, UrlTree to unauthorized page if not
 */
export const adminGuard: CanActivateFn = (): boolean | UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Check if user has admin privileges
  if (authService.isAdmin()) {
    return true;
  }

  // Not an admin - redirect to unauthorized page
  console.warn('Access denied: User is not an admin');
  return router.createUrlTree(['/unauthorized']);
};
